import React from 'react';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Location } from '../../assets/img/icons/header/Location.svg';
import { ReactComponent as CaretDown } from '../../assets/img/icons/header/CaretDown.svg';
import { ReactComponent as Xmark } from '../../assets/img/icons/common/Close.svg';
import { restaurantStatusColors } from '../../constants/restaurants.constants';
import { changeRestaurantUuid } from '../../redux/actions/loginAction';

const HeaderRestaurant = ({ opened, setOpened }) => {
  const dispatch = useDispatch();
  
  const userType = useSelector(state => state.login.userType);
  const restaurants = useSelector(state => state.login.restaurants);
  const restaurantUuid = useSelector(state => state.login.restaurantUuid);
  
  if (userType && userType !== 'USER' && restaurants.length !== 0) {
    const selectedRestaurant = restaurants.find(item => item.value === restaurantUuid);
    
    return (
      <div id="navbar_select_restaurant" className="header-global__container">
        <div
          className="global-option__container"
          onClick={() => {
            setOpened(prev => !prev);
          }}
        >
          <Location />
      
          <div className="global-option__container-text">
            <div data-toggle="tooltip" data-placement="bottom" title={selectedRestaurant?.label || ''}>
              {restaurantUuid === 'select' ? 'Global' : selectedRestaurant?.number || ''}
            </div>
          </div>
      
          {selectedRestaurant?.status && (
            <div
              className="global-option__container-status"
              style={{
                backgroundColor: restaurantStatusColors[selectedRestaurant?.status.toLowerCase()],
              }}
            />
          )}
      
          <div
            onClick={e => {
              if (restaurantUuid !== 'select') {
                e.stopPropagation();
                dispatch(changeRestaurantUuid('select'))
                setOpened(false);
              }
            }}
            className="global-option__container-icon"
          >
            {restaurantUuid === 'select' ? <CaretDown /> : <Xmark />}
          </div>
        </div>
    
        {opened ? (
          <ul className="global-option__container__ul">
            {(restaurantUuid === 'select' ? restaurants.slice(1) : restaurants).map(
              option => (
                <li
                  key={option.value}
                  value={option.value}
                  className={cx('navbar--option-li', { 'navbar--option-li-selected': option.value === selectedRestaurant?.value })}
                  onClick={e => {
                    e.stopPropagation();
                    dispatch(changeRestaurantUuid(option.value));
                    setOpened(false);
                  }}
                >
                  <div
                    className="global-option__item"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={`${option.number} - ${option.label}`}
                  >
                    <div className="option--item-label">{option.label}</div>
                
                    <div className="option--item-right">
                      <div className="option--item-number">{option.number}</div>
                  
                      <div
                        className="option--item-status"
                        style={{ backgroundColor: restaurantStatusColors[option.status.toLowerCase()] }}
                      />
                    </div>
                  </div>
                </li>
              )
            )}
          </ul>
        ) : null}
      </div>
    );
  }
  
  return null;
};

export default HeaderRestaurant;